import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: 'en'
  },
  mutations: {
    update_lang(state, val){
         state.lang = val;
    }
  },
  actions: {
  },
  modules: {
  }
})
